import { render } from "./ResourceTable.vue?vue&type=template&id=798d10b6&scoped=true"
import script from "./ResourceTable.vue?vue&type=script&lang=js"
export * from "./ResourceTable.vue?vue&type=script&lang=js"

import "./ResourceTable.vue?vue&type=style&index=0&id=798d10b6&lang=scss&scoped=true"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798d10b6"]])

export default __exports__